import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";

export default function ProbabilityBar({
  value,
  showLabel = true,
}: {
  value: number | null;
  showLabel?: boolean;
}) {
  if (value === null || value === undefined) {
    return <Typography variant="body2" color="text.secondary">--</Typography>;
  }

  const pct = Math.round(value * 100);
  const color = pct >= 40 ? "success" : pct >= 20 ? "warning" : "error";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 120 }}>
      <LinearProgress
        variant="determinate"
        value={pct}
        color={color}
        sx={{ flexGrow: 1, height: 8, borderRadius: 4 }}
      />
      {showLabel && (
        <Typography variant="body2" fontWeight={600} sx={{ minWidth: 36 }}>
          {pct}%
        </Typography>
      )}
    </Box>
  );
}
